import React from 'react';
import { Modal } from '@scuf/common';
import './BigModalUtil.scss';
import IModalProps from '@scuf/common/dist/components/Modal/IModalProps';

interface IBigModalUtilProps extends IModalProps {
  header?: string;
  headerRender?: () => JSX.Element;
  onClose?: () => void;
  closeIcon?: boolean;
  collapseTopSpace?: boolean;
}

const BigModalContent = (props: any) => {
  const { children, ...rest } = props;
  return <Modal.Content {...rest}>{props.children}</Modal.Content>;
};

const BigModalFooter = (props: any) => {
  const { children, ...rest } = props;
  return <Modal.Footer {...rest}>{props.children}</Modal.Footer>;
};

export class BigModalUtil extends React.Component<IBigModalUtilProps> {
  static Content: typeof BigModalContent = BigModalContent;
  static Footer: typeof BigModalFooter = BigModalFooter;
  constructor(props: IBigModalUtilProps) {
    super(props);
    this.state = {
      open: true
    };
  }

  /**
   * Find and return all children than are Content
   */
  getContent = () => {
    return React.Children.toArray(this.props.children).filter(
      (child: any) => child.type === BigModalUtil.Content
    );
  };

  /**
   * Find and return all children than are Footer
   */
  getFooter = () => {
    return React.Children.toArray(this.props.children).filter(
      (child: any) => child.type === BigModalUtil.Footer
    );
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const {
      header,
      headerRender,
      onClose,
      closeIcon,
      className,
      collapseTopSpace,
      ...rest
    } = this.props;

    const heading = headerRender ? headerRender() : header ? header : null;

    const content = this.getContent();

    const footer = this.getFooter();

    return (
      <Modal
        {...rest}
        className={
          className +
          ' fullmodal' +
          (collapseTopSpace ? '' : ' top-padded') +
          (footer.length > 0 ? ' with-footer' : '')
        }
        size={'fullscreen'}
        onClose={() => {
          this.handleClose();
        }}
        open={true}
        closeIcon={closeIcon === undefined || closeIcon ? true : false}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Header
          className={
            closeIcon === undefined || closeIcon ? undefined : 'no-icon'
          }
        >
          {heading}
        </Modal.Header>
        {content}
        {footer}
      </Modal>
    );
  }
}

export default BigModalUtil;
